<template>
	<div>
		<div class="card loginform">
			<h2>Login to Compass</h2>
			<div class="field">
				<InputText v-model.trim="userName" @input="formChanged" v-bind:class="{ 'p-invalid': loginFailureMessage != '' }" />
			</div>
			<div class="field">
				<InputText v-model.trim="password" @input="formChanged" v-bind:class="{ 'p-invalid': loginFailureMessage != '' }" type="password"></InputText>
			</div>
			<div style="height:30px;display:flex;">
				<Button @click="attemptLogin" label="Login" :loading="isLoading" :disabled="!canSubmit" />
				<div style="color:red; vertical-align:middle;margin-left:10px;">{{loginFailureMessage}}</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue } from 'vue-class-component';
	import { LoginRequest } from '../api-client/api-client'
	import { CompassApi } from '@/api-client/CompassApiProxy'

	export default class Login extends Vue {
		// Defaults
		userName = "";
		password = "";
		isLoading = false;
		loginFailureMessage = "";

		// Computed
		get canSubmit(): boolean {
			return (this.userName.length > 0) && (this.password.length > 0);
		}

		// Action - notify form changed
		formChanged(): void {
			// clear any error message
			this.loginFailureMessage = "";
		}

		// Action - attempt login
		attemptLogin(): void {
			// API will error if we don't have username and password
			if ((this.userName.length < 1) || (this.password.length < 1))
				return;

			this.isLoading = true;

			const apiClient = CompassApi.authApi(this.$store);
			const enteredCredentials = new LoginRequest({ userName: this.userName, password: this.password });
			apiClient.login(enteredCredentials)
				.then(result => {
					if (result.message === "OK") {
						// Notify the app that we have logged in 
						this.$store.dispatch('login', result.token);

						// Internal users can access any route in the app, but other users need to redirect in case they're on a route that's inaccessible
						if (!this.$store.getters.isInternalUser) {
							this.$router.push({ name: 'Dashboard' });
						}
					}
					else {
						this.loginFailureMessage = result.message as string;
						this.$store.dispatch('clear_state');
					}
					// Mark that async has completed
					this.isLoading = false;
				})
				.catch((error: Error) => {
					this.loginFailureMessage = error.message;

					// Ensure not logged in
					this.$store.dispatch('logout');
					// Mark that async has completed
					this.isLoading = false;
				});
		}
	}
</script>

<style scoped lang="scss">
	.loginform {
		// set up to position center horizontally & vertically
		position: absolute;
		margin: 0;
		top: 50%;
		left: 50%;
		// then translate x & y by 50% of my size
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		// specify usable width
		width: 50%;
		min-width: 320px;
		max-width: 500px;
	}
</style>